import StockopnameScreen from './index';
import CreateScreen from './create';
import DetailScreen from './detail';
import UpdateScreen from './update';

const routes = [
  {
    path: '/inventory/stockopname',
    component: StockopnameScreen,
  },
  {
    path: '/inventory/stockopname/create',
    component: CreateScreen,
  },
  {
    path: '/inventory/stockopname/:id',
    component: DetailScreen,
  },
  {
    path: '/inventory/stockopname/:id/update',
    component: UpdateScreen,
  },
];

export default routes;
